<template>
  <NetworkStatus v-if="isOffline" />
  <div v-else>
    <div
      class="modal fade"
      id="documentPreviewModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="documentPreviewModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="card">
            <div
              class="modal-header"
              style="border-bottom: 1px solid rgba(250, 250, 250, 0.4)"
            >
              <h6 class="modal-title fs-5" id="documentPreviewModalLabel">
                {{ $t("transfer.document_preview") }}
              </h6>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="document-preview-container">
                <div v-if="api_bank_certificate && api_bank_certificate.length > 0">
                  <img
                    v-if="isImageFile(api_bank_certificate)"
                    :src="api_bank_certificate"
                    class="img-fluid"
                    alt="Attestation bancaire"
                  />

                  <iframe
                    v-else-if="
                      api_bank_certificate.toLowerCase().endsWith('.pdf')
                    "
                    :src="api_bank_certificate"
                    width="100%"
                    height="500px"
                    frameborder="0"
                  ></iframe>

                  <div v-else class="alert alert-warning">
                    {{
                      $t("transfer.unsupported_document_format") ||
                      "Format de document non pris en charge"
                    }}
                    <a
                      :href="api_bank_certificate"
                      target="_blank"
                      class="btn btn-primary mt-2"
                    >
                      {{
                        $t("transfer.download_document") ||
                        "Télécharger le document"
                      }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="modal-footer"
              style="border-top: 1px solid rgba(250, 250, 250, 0.4)"
            >
              <argon-button
                :loading="loading"
                :active="buttonActive || showConfirmation"
                color="danger"
                variant="gradient"
                type="button"
                class="mt-1"
                data-bs-dismiss="modal"
                style="width: 150px; height: 50px; padding-top: 15px"
                @click="confirmeuplaod"
              >
                <span v-if="!loading">{{ $t("button.cancel") }}</span>
              </argon-button>

              <argon-button
                :loading="loading"
                :active="buttonActive || showConfirmation"
                color="success"
                variant="gradient"
                type="button"
                class="mt-1"
                style="width: 150px; height: 50px; padding-top: 15px"
                @click="goToUpdateCertificate"
              >
                <span v-if="!loading">{{ $t("button.modify") }}</span>
              </argon-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main">
      <!--==================   Period modal   ==================-->

      <div
        class="modal fade"
        id="dateFilterModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="card w-60 mx-auto">
              <div class="modal-header border-0">
                <h6 class="modal-title" id="exampleModalLabel">
                  {{ $t("transaction.modal_title") }}
                </h6>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <form @submit.prevent="applyDateFilter">
                <div class="modal-body">
                  <div class="mb-3">
                    <label for="startDate" class="form-label"
                      >{{ $t("transaction.start_date")
                      }}<em style="color: #f60000">*</em></label
                    >
                    <input
                      style="
                        background: transparent;
                        color: white;
                        border: 1px solid rgba(250, 250, 250, 0.4);
                      "
                      type="date"
                      v-model="filterStartDate"
                      class="form-control"
                      id="startDate"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label for="endDate" class="form-label"
                      >{{ $t("transaction.end_date") }}
                      <em style="color: #f60000">*</em></label
                    >
                    <input
                      style="
                        background: transparent;
                        color: white;
                        border: 1px solid rgba(250, 250, 250, 0.4);
                      "
                      type="date"
                      v-model="filterEndDate"
                      class="form-control"
                      id="endDate"
                      required
                    />
                  </div>
                </div>
                <div class="modal-footer border-0">
                  <button
                    style="
                      border: 1px solid rgba(255, 255, 255, 0.4);
                      color: white;
                    "
                    type="button"
                    class="btn bg-transparent"
                    data-bs-dismiss="modal"
                  >
                    {{ $t("button.close") }}
                  </button>
                  <button
                    data-bs-dismiss="modal"
                    type="submit"
                    class="btn btn-success"
                  >
                    {{ $t("transaction.filter") }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!--================== Modal montant pas reçu   ==================-->

      <div
        class="modal fade"
        id="pasreçu"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="card">
              <div class="modal-header border-0">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div v-if="selectedTransaction" class="time text-center">
                  <template
                    v-if="
                      hasClaimForTransaction(selectedTransaction.operation_id)
                    "
                  >
                    <div class="claim-status-message">
                      <template
                        v-if="
                          getClaimStatus(selectedTransaction.operation_id) === 0
                        "
                      >
                        <h6
                          class="modal-title fs-5 mb-4"
                          id="staticBackdropLabel"
                        >
                          {{ $t("transfer.late_transfer_title") }}
                        </h6>
                        <div
                          class="alert bg-warning w-80 mx-auto text-light fw-bold"
                        >
                          <h5>
                            <i class="bi bi-hourglass-split me-2"></i
                            >{{ $t("transfer.claim_status_pending") }}
                          </h5>
                        </div>
                      </template>
                      <template
                        v-else-if="
                          getClaimStatus(selectedTransaction.operation_id) === 1
                        "
                      >
                        <h6
                          class="modal-title fs-5 mb-4"
                          id="staticBackdropLabel"
                        >
                          {{ $t("transfer.late_transfer_title") }}
                        </h6>
                        <div
                          class="alert bg-info w-80 mx-auto text-light fw-bold"
                        >
                          <h5>
                            <i class="bi bi-arrow-repeat me-2"></i>
                            {{ $t("transfer.claim_status_processing") }}
                          </h5>
                        </div>
                      </template>
                      <template
                        v-else-if="
                          getClaimStatus(selectedTransaction.operation_id) === 2
                        "
                      >
                        <h6
                          class="modal-title fs-5 mb-4"
                          id="staticBackdropLabel"
                        >
                          {{ $t("transfer.late_transfer_title") }}
                        </h6>
                        <div
                          class="alert bg-success w-80 mx-auto text-light fw-bold"
                        >
                          <h5>
                            <i class="bi bi-check-circle me-2"></i>
                            {{ $t("transfer.claim_status_completed") }}
                          </h5>
                        </div>
                      </template>
                    </div>

                    <!-- Display transaction details with claim -->
                    <ul class="text-start w-60 mx-auto mt-3">
                      <li>
                        <div class="row">
                          <div class="col-4">
                            <strong>ID operation </strong>
                          </div>
                          <div class="col-8">
                            {{ selectedTransaction.operation_id }}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="row">
                          <div class="col-4">
                            <strong>{{ $t("transfer.amount") }} </strong>
                          </div>
                          <div class="col-8">
                            {{ currency_code }}
                            {{
                              Number(selectedTransaction.amount).toLocaleString(
                                this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }
                              )
                            }}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="row">
                          <div class="col-4">
                            <strong>{{ $t("transfer.start_date") }} </strong>
                          </div>
                          <div class="col-8">
                            {{
                              formatDateWithoutTime(
                                selectedTransaction.collected_from
                              )
                            }}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="row">
                          <div class="col-4">
                            <strong>{{ $t("transfer.end_date") }} </strong>
                          </div>
                          <div class="col-8">
                            {{
                              formatDateWithoutTime(
                                selectedTransaction.collected_until
                              )
                            }}
                          </div>
                        </div>
                      </li>
                    </ul>

                    <div class="w-60 mx-auto text-start ps-2">
                      <template
                        v-if="
                          getClaimDocument1(selectedTransaction?.operation_id)
                        "
                      >
                        <a
                          style="height: 50px; padding: 14px"
                          :href="
                            getClaimDocument1(selectedTransaction?.operation_id)
                          "
                          target="_blank"
                          class="btn btn-primary"
                          :title="$t('transfer.download')"
                          download
                        >
                          <i class="bi bi-download me-2"></i>
                          {{ $t("transfer.download_transfer_order") }}
                        </a>
                      </template>
                      <p v-else class="text-muted">
                        {{ $t("transfer.no_transfer_order_available") }}
                      </p>
                    </div>
                  </template>

                  <template v-else>
                    <i
                      class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"
                    ></i>
                    <template
                      v-if="
                        !isMoreThan72Hours(selectedTransaction.collected_until)
                      "
                    >
                      <p class="px-4">
                        {{ $t("transfer.late_transfer_p1") }}
                        {{
                          formatDateWithoutTime(
                            selectedTransaction.collected_from
                          )
                        }}. {{ $t("transfer.late_transfer_p2") }}
                        {{
                          calculateDatePlus72Hours(
                            selectedTransaction.collected_from
                          )
                        }}.
                        {{ $t("transfer.late_transfer_p3") }}
                      </p>
                    </template>
                    <template v-else>
                      <p class="px-4 w-60 mx-auto text-start">
                        {{ $t("transfer.late_transfer_p4") }}
                      </p>
                      <ul class="text-start w-60 mx-auto mt-3">
                        <li>
                          <div class="row">
                            <div class="col-4">
                              <strong>ID operation </strong>
                            </div>
                            <div class="col-8">
                              {{ selectedTransaction.operation_id }}
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="row">
                            <div class="col-4">
                              <strong>{{ $t("transfer.amount") }} </strong>
                            </div>
                            <div class="col-8">
                              {{ currency_code }}
                              {{
                                Number(
                                  selectedTransaction.amount
                                ).toLocaleString(
                                  this.$i18n.locale === "fr"
                                    ? "fr-FR"
                                    : "en-US",
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )
                              }}
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="row">
                            <div class="col-4">
                              <strong>{{ $t("transfer.start_date") }} </strong>
                            </div>
                            <div class="col-8">
                              {{
                                formatDateWithoutTime(
                                  selectedTransaction.collected_from
                                )
                              }}
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="row">
                            <div class="col-4">
                              <strong>{{ $t("transfer.end_date") }} </strong>
                            </div>
                            <div class="col-8">
                              {{
                                formatDateWithoutTime(
                                  selectedTransaction.collected_until
                                )
                              }}
                            </div>
                          </div>
                        </li>
                      </ul>
                    </template>
                  </template>
                </div>
              </div>

              <div class="modal-footer border-0 pb-5 mb-1">
                <argon-button
                  type="button"
                  class="btn bg-transparent"
                  data-bs-dismiss="modal"
                  v-if="
                    !hasClaimForTransaction(
                      selectedTransaction?.operation_id
                    ) && getClaimStatus(selectedTransaction?.operation_id) == 2
                  "
                  style="
                    width: 150px;
                    height: 50px;
                    padding-top: 15px;
                    border: 1px solid rgba(250, 250, 250, 0.4);
                  "
                >
                  {{ $t("button.cancel") }}
                </argon-button>

                <argon-button
                  v-if="
                    !hasClaimForTransaction(
                      selectedTransaction?.operation_id
                    ) && getClaimStatus(selectedTransaction?.operation_id) == 2
                  "
                  :loading="loading"
                  :active="buttonActive || showConfirmation"
                  color="success"
                  variant="gradient"
                  type="button"
                  class="mt-1"
                  style="
                    width: 150px;
                    height: 50px;
                    padding-top: 15px;
                    margin-right: 100px;
                  "
                  @click="handleSubmitClaim"
                >
                  {{ $t("button.claim") }}
                </argon-button>

                <argon-button
                  v-if="
                    hasClaimForTransaction(selectedTransaction?.operation_id) ||
                    getClaimStatus(selectedTransaction?.operation_id) !== 2
                  "
                  type="button"
                  class="btn bg-transparent text-light"
                  data-bs-dismiss="modal"
                  style="
                    width: 150px;
                    height: 50px;
                    padding-top: 15px;
                    border: 1px solid rgba(250, 250, 250, 0.4);
                    margin-right: 100px;
                  "
                >
                  {{ $t("button.close") }}
                </argon-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--================== Modal montant incorrect   ==================-->
      <div
        class="modal fade"
        id="conteste"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="card">
              <div class="modal-header border-0">
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div v-if="selectedTransaction" class="time text-center">
                  <template
                    v-if="
                      hasIncorrectAmountClaimForTransaction(
                        selectedTransaction.operation_id
                      ) &&
                      getIncorrectAmountClaimStatus(
                        selectedTransaction.operation_id
                      ) !== 2
                    "
                  >
                    <div class="claim-status-message">
                      <template
                        v-if="
                          getIncorrectAmountClaimStatus(
                            selectedTransaction.operation_id
                          ) === 0
                        "
                      >
                        <h6
                          class="modal-title fs-5 mb-4"
                          id="staticBackdropLabel"
                        >
                          {{ $t("transfer.contest_amount_title") }}
                        </h6>
                        <div
                          class="alert bg-warning w-60 mx-auto text-light fw-bold"
                        >
                          <h5>
                            <i class="bi bi-hourglass-split me-2"></i
                            >{{ $t("transfer.claim_status_pending") }}
                          </h5>
                        </div>
                      </template>
                      <template
                        v-else-if="
                          getIncorrectAmountClaimStatus(
                            selectedTransaction.operation_id
                          ) === 1
                        "
                      >
                        <h6
                          class="modal-title fs-5 mb-4"
                          id="staticBackdropLabel"
                        >
                          {{ $t("transfer.contest_amount_title") }}
                        </h6>
                        <div
                          class="alert bg-info w-60 mx-auto text-light fw-bold"
                        >
                          <h5>
                            <i class="bi bi-arrow-repeat me-2"></i>
                            {{ $t("transfer.claim_status_processing") }}
                          </h5>
                        </div>
                      </template>
                    </div>

                    <!-- Display transaction details with claim -->
                    <ul class="text-start w-60 mx-auto mt-3">
                      <li>
                        <div class="row">
                          <div class="col-5">
                            <strong>ID operation </strong>
                          </div>
                          <div class="col-7">
                            {{ selectedTransaction.operation_id }}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="row">
                          <div class="col-5">
                            <strong
                              >{{ $t("transfer.current_amount") }}
                            </strong>
                          </div>
                          <div class="col-7">
                            {{ currency_code }}
                            {{
                              Number(selectedTransaction.amount).toLocaleString(
                                this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }
                              )
                            }}
                          </div>
                        </div>
                      </li>

                      <li>
                        <div class="row">
                          <div class="col-5">
                            <strong
                              >{{ $t("transfer.requested_value") }}
                            </strong>
                          </div>
                          <div class="col-7">
                            {{ currency_code }}
                            {{
                              Number(
                                getExpectedAmount(
                                  selectedTransaction.operation_id
                                ) || selectedTransaction.amount
                              ).toLocaleString(
                                this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }
                              )
                            }}
                          </div>
                        </div>
                      </li>

                      <li>
                        <div class="row">
                          <div class="col-5">
                            <strong>{{ $t("transfer.start_date") }} </strong>
                          </div>
                          <div class="col-7">
                            {{
                              formatDateWithoutTime(
                                selectedTransaction.collected_from
                              )
                            }}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="row">
                          <div class="col-5">
                            <strong>{{ $t("transfer.end_date") }} </strong>
                          </div>
                          <div class="col-7">
                            {{
                              formatDateWithoutTime(
                                selectedTransaction.collected_until
                              )
                            }}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </template>

                  <template
                    v-else-if="
                      hasIncorrectAmountClaimForTransaction(
                        selectedTransaction.operation_id
                      ) &&
                      getIncorrectAmountClaimStatus(
                        selectedTransaction.operation_id
                      ) === 2
                    "
                  >
                    <div class="claim-status-message">
                      <h6
                        class="modal-title fs-5 mb-4"
                        id="staticBackdropLabel"
                      >
                        {{ $t("transfer.contest_amount_title") }}
                      </h6>

                      <div
                        class="alert bg-success w-80 mx-auto text-light fw-bold"
                      >
                        <h5>
                          <i class="bi bi-check-circle me-2"></i
                          >{{ $t("transfer.claim_status_completed") }}
                        </h5>
                      </div>
                    </div>

                    <ul class="text-start w-60 mx-auto mt-3">
                      <li>
                        <div class="row">
                          <div class="col-4">
                            <strong>ID operation </strong>
                          </div>
                          <div class="col-8">
                            {{ selectedTransaction.operation_id }}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="row">
                          <div class="col-4">
                            <strong>{{ $t("transfer.amount") }} </strong>
                          </div>
                          <div class="col-8">
                            {{ currency_code }}
                            {{
                              Number(selectedTransaction.amount).toLocaleString(
                                this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }
                              )
                            }}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="row">
                          <div class="col-4">
                            <strong>{{ $t("transfer.start_date") }} </strong>
                          </div>
                          <div class="col-8">
                            {{
                              formatDateWithoutTime(
                                selectedTransaction.collected_from
                              )
                            }}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="row">
                          <div class="col-4">
                            <strong>{{ $t("transfer.end_date") }} </strong>
                          </div>
                          <div class="col-8">
                            {{
                              formatDateWithoutTime(
                                selectedTransaction.collected_until
                              )
                            }}
                          </div>
                        </div>
                      </li>
                    </ul>

                    <div class="w-60 mx-auto text-start ps-2">
                      <template
                        v-if="
                          getClaimDocument(selectedTransaction?.operation_id)
                        "
                      >
                        <a
                          style="height: 50px; padding-top: 14px"
                          :href="
                            getClaimDocument(selectedTransaction?.operation_id)
                          "
                          target="_blank"
                          class="btn btn-primary"
                          :title="$t('transfer.download')"
                          download
                        >
                          <i class="bi bi-download me-2"></i>
                          {{ $t("transfer.download_transfer_order") }}
                        </a>
                      </template>
                      <p v-else class="text-muted">
                        {{ $t("transfer.no_transfer_order_available") }}
                      </p>
                    </div>

                    <div v-if="showForm" class="form text-start w-60 mt-4">
                      <form @submit.prevent="submitContestation">
                        <div class="mb-3">
                          <label for="montantActuel" class="form-label">{{
                            $t("transfer.contest_current_amount")
                          }}</label>
                          <input
                            type="number"
                            class="form-control"
                            id="montantActuel"
                            :value="selectedTransaction.amount"
                            disabled
                            style="
                              background: transparent;
                              color: white;
                              border: 1px solid rgba(250, 250, 250, 0.4);
                            "
                          />
                        </div>
                        <div class="mb-3">
                          <label for="montantAttendu" class="form-label"
                            >{{ $t("transfer.contest_pending_amount")
                            }}<em style="color: #f60000">*</em></label
                          >
                          <input
                            type="number"
                            :placeholder="$t('transfer.contest_placeholder')"
                            class="form-control"
                            id="montantAttendu"
                            v-model="current_amount"
                            required
                            style="
                              background: transparent;
                              color: white;
                              border: 1px solid rgba(250, 250, 250, 0.4);
                            "
                          />
                        </div>
                      </form>
                    </div>
                  </template>

                  <template v-else>
                    <div v-if="!showForm">
                      <i
                        class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"
                      ></i>
                      <p class="px-4 text-start w-60 mx-auto">
                        {{ $t("transfer.contest_amount_p1") }}
                      </p>
                      <ul class="text-start w-60 mx-auto mt-3">
                        <li>
                          <div class="row">
                            <div class="col-4">
                              <strong>ID operation </strong>
                            </div>
                            <div class="col-8">
                              {{ selectedTransaction.operation_id }}
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="row">
                            <div class="col-4">
                              <strong>{{ $t("transfer.amount") }} </strong>
                            </div>
                            <div class="col-8">
                              {{ currency_code }}
                              {{
                                Number(
                                  selectedTransaction.amount
                                ).toLocaleString(
                                  this.$i18n.locale === "fr"
                                    ? "fr-FR"
                                    : "en-US",
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )
                              }}
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="row">
                            <div class="col-4">
                              <strong>{{ $t("transfer.start_date") }} </strong>
                            </div>
                            <div class="col-8">
                              {{
                                formatDateWithoutTime(
                                  selectedTransaction.collected_from
                                )
                              }}
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="row">
                            <div class="col-4">
                              <strong>{{ $t("transfer.end_date") }} </strong>
                            </div>
                            <div class="col-8">
                              {{
                                formatDateWithoutTime(
                                  selectedTransaction.collected_until
                                )
                              }}
                            </div>
                          </div>
                        </li>
                      </ul>
                      <p class="px-4 text-start w-60 mx-auto">
                        {{ $t("transfer.contest_amount_p2") }}
                      </p>
                    </div>

                    <div v-if="showForm" class="form text-start w-60">
                      <form @submit.prevent="submitContestation">
                        <div class="mb-3">
                          <label for="montantActuel" class="form-label">{{
                            $t("transfer.contest_current_amount")
                          }}</label>
                          <input
                            type="number"
                            class="form-control"
                            id="montantActuel"
                            :value="selectedTransaction.amount"
                            disabled
                            style="
                              background: transparent;
                              color: white;
                              border: 1px solid rgba(250, 250, 250, 0.4);
                            "
                          />
                        </div>
                        <div class="mb-3">
                          <label for="montantAttendu" class="form-label"
                            >{{ $t("transfer.contest_pending_amount")
                            }}<em style="color: #f60000">*</em></label
                          >
                          <input
                            type="number"
                            :placeholder="$t('transfer.contest_placeholder')"
                            class="form-control"
                            id="montantAttendu"
                            v-model="current_amount"
                            required
                            style="
                              background: transparent;
                              color: white;
                              border: 1px solid rgba(250, 250, 250, 0.4);
                            "
                          />
                        </div>
                      </form>
                    </div>
                  </template>
                </div>
              </div>

              <div class="modal-footer border-0 pb-5 mb-1">
                <template
                  v-if="
                    !hasIncorrectAmountClaimForTransaction(
                      selectedTransaction?.operation_id
                    )
                  "
                >
                  <argon-button
                    v-if="!showForm"
                    color="success"
                    variant="gradient"
                    type="button"
                    class="mt-1"
                    style="
                      width: 150px;
                      height: 50px;
                      padding-top: 15px;
                      margin-right: 100px;
                    "
                    @click="showForm = true"
                  >
                    {{ $t("button.continue") }}
                  </argon-button>

                  <template v-if="showForm">
                    <argon-button
                      type="button"
                      class="mt-1 bg-transparent"
                      data-bs-dismiss="modal"
                      style="
                        width: 150px;
                        height: 50px;
                        padding-top: 15px;
                        border: 1px solid rgba(250, 250, 250, 0.4);
                      "
                      @click="showForm = false"
                    >
                      {{ $t("button.cancel") }}
                    </argon-button>

                    <argon-button
                      :loading="loading"
                      :active="buttonActive || showConfirmation"
                      color="success"
                      variant="gradient"
                      type="button"
                      class="mt-1"
                      style="
                        width: 150px;
                        height: 50px;
                        padding-top: 15px;
                        margin-right: 100px;
                      "
                      @click="handleSubmitIncorrectAmount"
                    >
                      {{ $t("button.claim") }}
                    </argon-button>
                  </template>
                </template>

                <argon-button
                  v-if="
                    hasIncorrectAmountClaimForTransaction(
                      selectedTransaction?.operation_id
                    )
                  "
                  type="button"
                  class="btn bg-transparent"
                  data-bs-dismiss="modal"
                  style="
                    border: 1px solid rgba(250, 250, 250, 0.4);
                    width: 150px;
                    height: 50px;
                    padding-top: 15px;
                    margin-right: 100px;
                  "
                  color="secondary"
                >
                  {{ $t("button.close") }}
                </argon-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-transaction">
        <div class="container-fluid">
          <spinner
            class="text-center mt-8 mb-8"
            v-if="loading"
            style="height: 200px"
          >
            <div>
              <span class="mt-4">
                <Spinner></Spinner>
              </span>
            </div>
          </spinner>

          <!--==================  Bank information  ==================-->

          <div
            class="card-api mt-4 mb-3 px-3 pb-2 border"
            style="
              border: 1px solid rgba(250, 250, 250, 0.5);
              border-radius: 5px;
              background: #111c44;
            "
            v-else-if="status_code && !status_code <= 104"
          >
            <div class="card-api-content d-flex justify-content-between">
              <div class="d-flex mt-3 pt-1">
                <div class="key pe-2 me-3">
                  <img
                    style="height: 80px"
                    class="ms-2 me-1 rounded-circle"
                    :src="this.bank_logo"
                    alt=""
                  />
                </div>
                <div class="text mx-3">
                  <h6 style="font-size: 14px">
                    <span class="info_bank" v-if="detail && detail.data">
                      {{ this.bank_slug }}:
                    </span>
                    <span> {{ formatAccountNumber(transaction_number) }}</span>
                  </h6>
                  <p style="font-size: 14px">
                    {{ $t("transfer.info_p") }} {{ currency_code }}
                    {{
                      Number(this.transfer_min_amount).toLocaleString(
                        this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                        {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        }
                      )
                    }}
                    -
                    <router-link
                      to="/settings#payment-settings"
                      @click="handleParemNavigation"
                      style="color: #60a5fa !important"
                      >{{ $t("button.modify") }}</router-link
                    >
                  </p>
                  <h6 style="font-size: 14px; margin-top: -10px">
                    {{ $t("transfer.info_p2") }}
                  </h6>
                </div>
              </div>

              <a
                class="mt-3"
                title="Cliquez pour visualiser"
                data-bs-toggle="modal"
                data-bs-target="#documentPreviewModal"
                style="color: #60a5fa !important; font-size: 14px"
                href="#"
              >
                <span class="me-1">{{ $t("transfer.see_doc") }}</span>
                <i class="fa-solid fa-arrow-right"></i>
              </a>
            </div>
          </div>

          <!--================== Table ==================-->

          <div class="content-table">
            <div class="d-flex justify-content-between">
              <div style="margin-top: 100px">
                <label for="" style="transform: translateY(-30px)">
                  {{ $t("transfer.period") }}</label
                >
                <div class="dropdown" id="drop2">
                  <button
                    class="btn dropdown-toggle text-light fw-bold ps-2"
                    type="button"
                    data-bs-toggle="dropdown"
                    style="transform: translateY(-30px)"
                  >
                    {{ $t("transfer.all_periods") }}
                  </button>
                  <ul class="dropdown-menu pt-0 pb-0">
                    <li
                      class="dropdown-item"
                      @click="
                        setPeriodFilter('all', $t('transfer.all_periods'))
                      "
                    >
                      {{ $t("transfer.all_periods") }}
                    </li>
                    <li
                      class="dropdown-item"
                      @click="setPeriodFilter('today', $t('transfer.today'))"
                    >
                      {{ $t("transfer.today") }}
                    </li>
                    <li
                      class="dropdown-item"
                      @click="
                        setPeriodFilter('yesterday', $t('transfer.yesterday'))
                      "
                    >
                      {{ $t("transfer.yesterday") }}
                    </li>
                    <li
                      class="dropdown-item"
                      @click="
                        setPeriodFilter(
                          'lastSevenDays',
                          $t('transfer.since_the_seven_days')
                        )
                      "
                    >
                      {{ $t("transfer.since_the_seven_days") }}
                    </li>
                    <li
                      class="dropdown-item"
                      @click="
                        setPeriodFilter(
                          'lastTwentyEightDays',
                          $t('transfer.last_28_days')
                        )
                      "
                    >
                      {{ $t("transfer.last_28_days") }}
                    </li>
                    <li
                      class="dropdown-item"
                      data-bs-toggle="modal"
                      data-bs-target="#dateFilterModal"
                      @click="
                        setPeriodFilter('custom', $t('transaction.filter_date'))
                      "
                    >
                      {{ $t("transaction.filter_date") }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="card px-0 mt-2">
              <div class="card-body px-0">
                <div class="row">
                  <div class="col-md-6 px-0"></div>
                  <div
                    class="col-md-6 text-end"
                    style="padding-right: 30px"
                  ></div>
                </div>

                <spinner
                  class="text-center mt-8 mb-8"
                  v-if="loading"
                  style="height: 200px"
                >
                  <div>
                    <span class="mt-4">
                      <Spinner></Spinner>
                    </span>
                  </div>
                </spinner>

                <table
                  class="table px-0 mt-6 mb-6"
                  v-else-if="transfers.length > 0"
                >
                  <thead>
                    <tr
                      style="border-bottom: 1px solid rgba(255, 255, 255, 0.1)"
                    >
                      <th class="border-0">ID operation</th>
                      <th
                        class="border-0 text-start w-25"
                        style="text-transform: none"
                      >
                        {{ $t("transfer.start_date") }}
                      </th>

                      <th
                        class="border-0 text-start w-25"
                        style="text-transform: none"
                      >
                        {{ $t("transfer.end_date") }}
                      </th>

                      <th class="border-0 w-25 text-start px-0">
                        {{ $t("transaction.status") }}
                      </th>

                      <th
                        class="border-0 w-25 text-end"
                        style="text-decoration: none"
                      >
                        {{ $t("transfer.amount") }}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="list in transfers"
                      :key="list.id"
                      style="
                        position: relative;
                        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                      "
                      class="transfer-row"
                    >
                      <td class="px-4 border-0 position-relative">
                        <span v-if="list.operation_id == null">
                          -----------
                        </span>
                        <span v-else>
                          {{ list.operation_id }}
                        </span>
                      </td>

                      <td class="ps-4 border-0 position-relative">
                        {{ formatDate(list.collected_from) }}
                      </td>

                      <td class="ps-4 border-0 position-relative">
                        {{ formatDate(list.collected_until) }}
                      </td>

                      <td
                        class="ps-0 pe-7 border-0 position-relative d-flex"
                        v-if="list.status == 303"
                      >
                        <span class="status-code bg-gradient-success mx-1">
                        </span>
                        {{ $t("transfer.executed") }}
                      </td>

                      <td
                        class="ps-0 pe-7 border-0 position-relative d-flex"
                        v-if="list.status == 302"
                      >
                        <span class="status-code bg-warning mx-1"> </span>
                        {{ $t("transfer.processing") }}
                      </td>

                      <td
                        class="ps-0 pe-7 border-0 position-relative d-flex text-filter"
                        v-if="list.status == 301"
                      >
                        <span class="status-code mx-1"> </span>
                        {{ $t("transfer.ready") }}
                      </td>

                      <td class="text-end px-4 border-0 position-relative">
                        {{ currency_code }}
                        <span class="text-filter">
                          {{
                            Number(list.amount).toLocaleString(
                              this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              }
                            )
                          }}
                        </span>

                        <div
                          class="btn-group"
                          id="btn-group"
                          v-if="isWithinOneWeek(list.collected_until)"
                        >
                          <button
                            type="button"
                            class="btn dropdown-toggle dropdown-table"
                            id="dropdown-table"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {{ $t("transfer.reclamation") }}
                          </button>

                          <ul class="dropdown-menu py-0" id="dropdown-menu">
                            <li
                              data-bs-toggle="modal"
                              style="
                                border-bottom: 1px solid
                                  rgba(250, 250, 250, 0.5);
                              "
                              data-bs-target="#pasreçu"
                              @click="openReclamationModal('pasrecu', list)"
                              v-if="list.status == 301"
                            >
                              <a
                                class="dropdown-item py-2"
                                href="#"
                                @click.prevent
                                >{{ $t("transfer.late_transfer_title") }}
                              </a>
                            </li>
                            <li
                              data-bs-toggle="modal"
                              data-bs-target="#conteste"
                              @click="openReclamationModal('conteste', list)"
                              v-if="list.status == 301"
                            >
                              <a
                                class="dropdown-item py-2"
                                href="#"
                                @click.prevent
                                >{{ $t("transfer.contest_amount_title") }}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <!--================== NO transaction ==================-->
                <div class="else text-center pb-5" v-else>
                  <div class="container">
                    <div class="text mt-3">
                      <img
                        class="image"
                        src="@/assets/img/transaction.png"
                        alt=""
                      />
                      <h5 class="mt-4">{{ $t("transfer.no_transfer") }}</h5>

                      <!---
                                <p class="mt-4 px-4">
                                    Utque proeliorum periti rectores primo catervas densas opponunt et fortes,
                                    deinde leves armaturas, post iaculatores
                                    ultimasque subsidiales acies, si fors adegerit, iuvaturas, ita praepositis urbanae.
                                </p>
                        -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--================== Loading  ==================-->
          <spinner
            class="text-center mt-8 mb-8"
            v-if="loading"
            style="height: 200px"
          >
            <div>
              <span class="mt-4">
                <Spinner></Spinner>
              </span>
            </div>
          </spinner>

          <!--==================Upload Bank informations  ==================-->
          <div v-else-if="status_code && status_code <= 104">
            <div v-if="claims2 && claims2.data && claims2.data.length > 0">
              <!-- Status 0: En attente -->
              <div v-if="claims2.data[0].status === 0" class="card mt-5">
                <div class="card-body text-center ext-light fw-bold py-7">
                  <i class="bi bi-hourglass-split text-warning fs-2 mb-3"></i>
                  <h5>{{ $t("transfer.claim_status_pending1") }}</h5>
                </div>
              </div>

              <!-- Status 1: En cours de traitement -->
              <div v-else-if="claims2.data[0].status === 1" class="card mt-5">
                <div class="card-body text-center ext-light fw-bold py-7">
                  <i class="bi bi-arrow-repeat text-info fs-2 mb-3"></i>
                  <h5>{{ $t("transfer.claim_status_processing1") }}</h5>
                </div>
              </div>
            </div>

            <!-- Aucune réclamation trouvée, afficher le composant Nobankdoc par défaut -->
            <Nobankdoc v-else class="mt-5" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "../components/Spinner.vue";
import ArgonButton from "@/components/ArgonButton";
import {
  getTransfers,
  getxpconnection,
  xpayconnection,
  submit_claims_late_transfer,
  submit_claims_incorrect_amount,
  getCleams,
} from "@/utils/services";
import Nobankdoc from "@/views/components/Nobankdocs.vue";
import NetworkStatus from "@/views/components/NetworkStatus.vue";
import api_config from "@/config";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

function getFormattedDate() {
  const today = new Date();

  const start_date = "2020-01-01 00:00:00";

  // Current date with full precision
  const endYear = today.getFullYear();
  const endMonth = String(today.getMonth() + 1).padStart(2, "0");
  const endDay = String(today.getDate()).padStart(2, "0");
  const end_date = `${endYear}-${endMonth}-${endDay} 23:59:59`;

  return { start_date, end_date };
}

/**
function getFormattedDate() {
  const start_date = "2024-08-03 00:00:00";
  const end_date = "2024-09-03 00:00:00";
  return { start_date, end_date };
}
*/

export default {
  name: "historique-Transaction",
  components: { Spinner, Nobankdoc, NetworkStatus, ArgonButton },
  data() {
    return {
      loading: false,
      transactionSummary: {
        total: { count: 0, amount: 0 },
        successful: { count: 0, amount: 0 },
        running: { count: 0, amount: 0 },
        failed: { count: 0, amount: 0 },
      },
      schoolId: "",
      xpay_connection_id: "",
      bank_slug: "",
      transaction_number: "",
      transfer_min_amount: "",
      bank_logo: "",
      transfers: [],
      detail: [],
      filterStartDate: "",
      filterEndDate: "",
      selectedPeriodLabel: this.$t("transfer.all_periods"),
      selectedPeriod: null,
      status_code: "",
      isOffline: false,
      selectedTransaction: null,
      showForm: false,
      montantAttendu: null,
      currency_code: api_config.CURRENCY_CODE,
      buttonActive: false,
      showConfirmation: false,
      school_name: "",
      school_bank_logo: "",
      current_amount: "",
      claims: [],
      claims1: [],
      claims2: [],
      bank_certificate: "",
      api_bank_certificate: "", // Store bank certificate from API response
      status: "",
    };
  },

  methods: {
    getClaimDocument(operationId) {
      if (
        !this.claims1 ||
        !this.claims1.data ||
        !Array.isArray(this.claims1.data)
      ) {
        return null;
      }

      const claim = this.claims1.data.find(
        (claim) => claim.data && claim.data.id_operation === operationId
      );

      return claim && claim.document ? claim.document : null;
    },

    getClaimDocument1(operationId) {
      if (
        !this.claims ||
        !this.claims.data ||
        !Array.isArray(this.claims.data)
      ) {
        return null;
      }

      const claim = this.claims.data.find(
        (claim) => claim.data && claim.data.id_operation === operationId
      );

      return claim && claim.document ? claim.document : null;
    },
    goToUpdateCertificate() {
      // Nettoyer la modal et son backdrop
      document.body.classList.remove("modal-open");
      const modalBackdrops = document.getElementsByClassName("modal-backdrop");
      for (const backdrop of modalBackdrops) {
        backdrop.parentNode.removeChild(backdrop);
      }

      // Rediriger vers la page de mise à jour
      this.$router.push("/update-bank-certificate");
    },

    isImageFile(url) {
      if (!url) return false;
      const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp"];
      return imageExtensions.some((ext) => url.toLowerCase().endsWith(ext));
    },

    getExpectedAmount(operationId) {
      if (
        !this.claims1 ||
        !this.claims1.data ||
        !Array.isArray(this.claims1.data)
      ) {
        return null;
      }

      const claim = this.claims1.data.find(
        (claim) => claim.data && claim.data.id_operation === operationId
      );

      return claim ? claim.data.expected_amount : null;
    },

    hasIncorrectAmountClaimForTransaction(operationId) {
      if (
        !this.claims1 ||
        !this.claims1.data ||
        !Array.isArray(this.claims1.data)
      ) {
        return false;
      }

      return this.claims1.data.some(
        (claim) => claim.data && claim.data.id_operation === operationId
      );
    },

    getIncorrectAmountClaimStatus(operationId) {
      if (
        !this.claims1 ||
        !this.claims1.data ||
        !Array.isArray(this.claims1.data)
      ) {
        return null;
      }

      const claim = this.claims1.data.find(
        (claim) => claim.data && claim.data.id_operation === operationId
      );

      return claim ? claim.status : null;
    },

    hasClaimForTransaction(operationId) {
      if (
        !this.claims ||
        !this.claims.data ||
        !Array.isArray(this.claims.data)
      ) {
        return false;
      }

      return this.claims.data.some(
        (claim) => claim.data && claim.data.id_operation === operationId
      );
    },

    getClaimStatus(operationId) {
      if (
        !this.claims ||
        !this.claims.data ||
        !Array.isArray(this.claims.data)
      ) {
        return null;
      }

      const claim = this.claims.data.find(
        (claim) => claim.data && claim.data.id_operation === operationId
      );

      return claim ? claim.status : null;
    },

    isWithinOneWeek(endDate) {
      const end = new Date(endDate);
      const now = new Date();
      const diffInDays = (now - end) / (1000 * 60 * 60 * 24);
      return diffInDays <= 7;
    },

    formatDateWithoutTime(dateString) {
      if (!dateString) return "N/A";
      try {
        const date = new Date(dateString);
        if (isNaN(date)) return "Invalid Date";

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
      } catch (error) {
        console.error("Error formatting date:", error);
        return "Invalid Date";
      }
    },

    calculateDatePlus72Hours(dateString) {
      if (!dateString) return "N/A";
      try {
        const date = new Date(dateString);
        if (isNaN(date)) return "Invalid Date";

        const datePlus72 = new Date(date.getTime() + 72 * 60 * 60 * 1000);

        const year = datePlus72.getFullYear();
        const month = String(datePlus72.getMonth() + 1).padStart(2, "0");
        const day = String(datePlus72.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
      } catch (error) {
        console.error("Error calculating date:", error);
        return "Invalid Date";
      }
    },

    submitContestation() {
      console.log("Contestation soumise:", {
        transactionId: this.selectedTransaction.operation_id,
        montantActuel: this.selectedTransaction.amount,
        montantAttendu: this.montantAttendu,
      });

      this.showForm = false;
      this.montantAttendu = null;
    },

    openReclamationModal(type, transaction) {
      this.selectedTransaction = transaction;
      this.showForm = false;
      this.montantAttendu = null;
    },

    isMoreThan72Hours(endDate) {
      const end = new Date(endDate);
      const now = new Date();
      const diffInHours = (now - end) / (1000 * 60 * 60);
      return diffInHours >= 72;
    },

    formatNumber(number) {
      return Number(number).toLocaleString(
        this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }
      );
    },

    async updateOnlineStatus() {
      if (navigator.onLine) {
        try {
          await this.checkConnection();
          this.isOffline = false;
        } catch (error) {
          console.error("Error checking connection:", error);
          this.isOffline = true;
        }
      } else {
        this.isOffline = true;
      }
    },

    async checkConnection(sf_school_id) {
      try {
        await Promise.all([xpayconnection(sf_school_id)]);
        this.apiError = false;
      } catch (error) {
        console.error("API Error:", error);
        this.apiError = true;
      }
    },

    handleParemNavigation() {
      this.$router
        .push({
          path: "/settings",
          hash: "#payment-settings",
        })
        .then(() => {
          this.$nextTick(() => {
            const tryScroll = (attempts = 0) => {
              const element = document.querySelector("#payment-settings");
              if (element) {
                element.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              } else if (attempts < 5) {
                setTimeout(() => tryScroll(attempts + 1), 100);
              }
            };
            tryScroll();
          });
        })
        .catch((err) => {
          console.error("Erreur de navigation:", err);
        });
    },
    getFormattedDate,
    setPeriodFilter(period, label) {
      this.selectedPeriod = period;
      this.selectedPeriodLabel = label;

      switch (period) {
        case "all":
          this.fetchTransfers();
          break;
        case "today":
          this.setFilterToday();
          break;
        case "yesterday":
          this.setFilterYesterday();
          break;
        case "lastSevenDays":
          this.setFilterLastSevenDays();
          break;
        case "lastTwentyEightDays":
          this.setFilterLastTwentyEightDays();
          break;
        case "custom":
          break;
      }
    },

    setFilterToday() {
      const today = new Date();
      this.filterStartDate = this.formatDateToSQL(today);
      this.filterEndDate = this.formatDateToSQL(today);
      this.applyDateFilter();
    },

    setFilterYesterday() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      this.filterStartDate = this.formatDateToSQL(yesterday);
      this.filterEndDate = this.formatDateToSQL(yesterday);
      this.applyDateFilter();
    },

    setFilterLastSevenDays() {
      const today = new Date();
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 7);
      this.filterStartDate = this.formatDateToSQL(sevenDaysAgo);
      this.filterEndDate = this.formatDateToSQL(today);
      this.applyDateFilter();
    },

    setFilterLastTwentyEightDays() {
      const today = new Date();
      const twentyEightDaysAgo = new Date(today);
      twentyEightDaysAgo.setDate(today.getDate() - 28);
      this.filterStartDate = this.formatDateToSQL(twentyEightDaysAgo);
      this.filterEndDate = this.formatDateToSQL(today);
      this.applyDateFilter();
    },

    formatDate(dateString) {
      if (!dateString) return "N/A";
      try {
        const date = new Date(dateString);
        if (isNaN(date)) return "Invalid Date";

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}`;
      } catch (error) {
        console.error("Error formatting date:", error);
        return "Invalid Date";
      }
    },

    formatAccountNumber(number) {
      if (!number) return "";
      return number.replace(/(\d{5})(\d{5})(\d{11})(\d{2})/, "$1-$2-$3-$4");
    },

    async fetchxpayconnection() {
      this.loading = true;
      const sf_school_id = this.schoolId;

      try {
        this.loading = true;
        let response = await xpayconnection(sf_school_id);

      if (response && response.length > 0) {
        const connection = response[0];
        this.xpay_connection_id = connection.id;
        this.bank_slug = connection.bank_name;
        this.school_name = connection.school_name;
        this.transfer_min_amount = connection.transfer_min_amount;
        this.transaction_number = connection.school_account_number;

        this.bank_logo = connection.school_bank_logo;
        this.status_code = connection.status_code;
        this.api_bank_certificate = connection.bank_certificate; // Store bank certificate from API

        localStorage.setItem("xpay_connection_id", this.xpay_connection_id);

        if (this.xpay_connection_id) {
          await this.fetchTransfers();
          await this.fetchXpconnection();
          await this.fetchgetclaimsbankinformation();
        }
      } else {
        console.error("Invalid response data or empty array:", response);
      }
      } catch (error) {
        console.error("Error during getconnection call:", error);
      } finally {
        this.loading = false;
      }
    },

    async fetchTransfers() {
      const xpay_connection_id = this.xpay_connection_id;
      const { start_date, end_date } = this.getFormattedDate();
      this.loading = true;

      try {
        let response = await getTransfers(
          xpay_connection_id,
          start_date,
          end_date
        );
        this.transfers = response || [];
        this.transactionSummary = response.summary || {
          total: { count: 0, amount: 0 },
          successful: { count: 0, amount: 0 },
          running: { count: 0, amount: 0 },
          failed: { count: 0, amount: 0 },
        };
      } catch (error) {
        console.error("Error fetching transfers:", error);
      } finally {
        this.loading = false;
      }
    },

    formatDateToSQL(date) {
      if (!date) return "";
      const selectedDate = new Date(date);
      const year = selectedDate.getFullYear();
      const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
      const day = String(selectedDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day} 00:00:00`;
    },

    async applyDateFilter() {
      if (!this.filterStartDate || !this.filterEndDate) {
        alert("Veuillez sélectionner les deux dates");
        return;
      }

      const start_date = this.formatDateToSQL(this.filterStartDate);
      const end_date = this.formatDateToSQL(this.filterEndDate);

      try {
        const response = await getTransfers(
          this.xpay_connection_id,
          start_date,
          end_date
        );
        this.transfers = response || [];
      } catch (error) {
        console.error("Erreur lors de la récupération des transferts :", error);
      }
    },

    async handleSubmitIncorrectAmount() {
      if (!this.selectedTransaction) return;
      if (this.loading) return;
      try {
        this.loading = true;
        this.buttonActive = true;
        const formatDate = (dateString) => {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };
        const response = await submit_claims_incorrect_amount(
          "Transfer",
          "Incorrect transfer amount",
          this.school_name,
          this.xpay_connection_id,
          this.selectedTransaction.operation_id,
          this.current_amount,
          this.selectedTransaction.amount,
          formatDate(this.selectedTransaction.collected_from),
          formatDate(this.selectedTransaction.collected_until)
        );

        if (response) {
          toast.success(this.$t("transfer.claim_submitted_successfully"));

          // Rafraîchir les données
          await this.fetchTransfers();
        }
      } catch (error) {
        console.error("Erreur lors de la soumission de la réclamation:", error);
        toast.success(this.$t("transfer.claim_submission_error"));
      } finally {
        this.loading = false;
        this.buttonActive = false;
      }
    },

    async handleSubmitClaim() {
      if (!this.selectedTransaction) return;
      if (this.loading) return;

      try {
        this.loading = true;
        this.buttonActive = true;
        const formatDate = (dateString) => {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        const response = await submit_claims_late_transfer(
          "Bank transfers late",
          "Transfer",
          this.school_name,
          this.xpay_connection_id,
          this.selectedTransaction.operation_id,
          this.selectedTransaction.amount,
          formatDate(this.selectedTransaction.collected_from),
          formatDate(this.selectedTransaction.collected_until)
        );

        if (response) {
          const message = this.$t("transfer.claim_submitted_successfully");
          toast.success(message, {
            autoClose: 3000,
          });

          setTimeout(() => {
            window.location.reload();
            this.transfer_min_amount = this.selectedAmount;
          }, 3000);
        }
      } catch (error) {
        console.error("Erreur lors de la soumission de la réclamation:", error);
        toast.success(this.$t("transfer.claim_submission_error"));
      } finally {
        this.loading = false;
        this.buttonActive = false;
      }
    },

    async fetchXpconnection() {
      const connection_id = this.xpay_connection_id;

      try {
        let response = await getxpconnection(connection_id);
        this.detail = response || [];
      } catch (error) {
        console.error("Error fetching xpconnection detail:", error);
      } finally {
        this.loading = false;
      }
    },

    async fetchgetclaimsLateTransfer() {
      const connection_id = this.xpay_connection_id;
      const type = "Transfer";
      const title = "Bank transfers late";

      try {
        let response = await getCleams(connection_id, type, title);
        this.claims = response || [];
      } catch (error) {
        console.error("Error fetching claims:", error);
      } finally {
        this.loading = false;
      }
    },

    async fetchgetclaimsIncorrectAmount() {
      const connection_id = this.xpay_connection_id;
      const type = "Transfer";
      const title = "Incorrect transfer amount";

      try {
        let response = await getCleams(connection_id, type, title);
        this.claims1 = response || [];
      } catch (error) {
        console.error("Error fetching incorrect amount claims:", error);
      } finally {
        this.loading = false;
      }
    },

    async fetchgetclaimsbankinformation() {
      const connection_id = this.xpay_connection_id;
      const type = "AppConfig";
      const title = api_config.UPDATE_BANK_INFORMATION_TITLE;

      try {
        let response = await getCleams(connection_id, type, title);
        this.claims2 = response || [];

        if (
          this.claims2 &&
          this.claims2.data &&
          Array.isArray(this.claims2.data) &&
          this.claims2.data.length > 0
        ) {
          this.status = this.claims2.data.map((claim) => claim.status);

          const statusTwoClaims = this.claims2.data.filter(
            (claim) => claim.status === 2
          );

          if (statusTwoClaims.length > 0) {
            this.bank_certificate = statusTwoClaims
              .filter((claim) => claim.data && claim.data.bank_certificate)
              .map((claim) => claim.data.bank_certificate);

            if (this.bank_certificate && this.bank_certificate.length > 0) {
              localStorage.setItem(
                "bank_certificate",
                JSON.stringify(this.bank_certificate)
              );
            }
          }
        }
      } catch (error) {
        console.error("Error fetching bank information claims:", error);
      } finally {
        this.loading = false;
      }
    },
  },

  async mounted() {
    await this.updateOnlineStatus();
    this.schoolId = localStorage.getItem("schoolId");

    const storedBankInfo = localStorage.getItem("bank_certificate");
    if (storedBankInfo) {
      try {
        this.bank_certificate = JSON.parse(storedBankInfo);
      } catch (e) {
        console.error("Error parsing bank information from localStorage:", e);
      }
    }

    await this.fetchxpayconnection();

    await Promise.all([
      this.fetchTransfers(),
      this.fetchgetclaimsLateTransfer(),
      this.fetchgetclaimsIncorrectAmount(),
      this.fetchgetclaimsbankinformation(),
    ]);

    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);

    if (!this.isOffline) {
      await this.fetchxpayconnection();
    }
  },

  beforeUnmount() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
};
</script>

<style>
.info_bank img {
  height: 30px;
  width: 30px;
}

#form {
  background: none;
  border: 1px solid rgba(250, 250, 250, 0.6);
  height: 45px;
}

#card .card1 {
  padding-top: 20px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 20px;
  color: white;
  border-radius: 10px;
}

#card .card1 span {
  font-size: 18px;
}

#card .card1 .price {
  font-size: 25px;
  font-weight: bold;
}

.table tbody tr td {
  padding-top: 13px;
  padding-bottom: 13px;
}

#span-table {
  width: 150px;
}

.transfer-row {
  position: relative;
  transition: 3s;
}

#dropdown-table {
  background: #4f61c4;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
}

#btn-group {
  border: none;
  position: absolute;
  right: 170px;
  top: 12px;
  display: none;
}

.transfer-row:hover {
  background: rgba(255, 255, 255, 0.1);
}

.transfer-row:hover #btn-group {
  display: block;
}

.status-code {
  width: 15px;
  height: 15px;
  border-radius: 100%;
  background: #60a5fa;
  content: "";
  display: block;
  transform: translateY(5px);
}

#dropdown-menu {
  background: #111c44;
  color: white;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

#dropdown-menu .dropdown-item {
  color: white;
  border-bottom: 1px solid rgba(250, 250, 250, 250, 0.4);
}

#dropdown-menu .dropdown-item:hover {
  background: rgba(250, 250, 250, 250, 0.1);
  color: black;
}

#drop2 .dropdown-toggle {
  width: 200px;
  color: white;
  background: #111c45;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
}

#drop2 .dropdown-menu .dropdown-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(250, 250, 250, 0.1);
  transition: background-color 0.3s ease;
  color: white;
  height: 45px;
  padding-top: 12px;
  transition: 0.4s ease;
}
#drop2 .dropdown-menu .dropdown-item:hover{
  color: black;
}

#drop2 .dropdown-menu {
  border-radius: 4px;
  width: 100%;
  max-width: 200px;
}
</style>
